import { render, staticRenderFns } from "./sheet-view-group-tab.vue?vue&type=template&id=287b08f7&scoped=true&"
import script from "./sheet-view-group-tab.vue?vue&type=script&lang=js&"
export * from "./sheet-view-group-tab.vue?vue&type=script&lang=js&"
import style0 from "./sheet-view-group-tab.vue?vue&type=style&index=0&id=287b08f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b08f7",
  null
  
)

export default component.exports